module.exports = __webpack_public_path__ + "static/media/logo.39b04287.png";